import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/comment/getList',
        method: 'post',
        data: data
    })
}

export function updateShow(data) {
    return request({
        url: '/backend/comment/updateShow',
        method: 'post',
        data: data
    })
}

export function del(data) {
    return request({
        url: '/backend/comment/delete',
        method: 'post',
        data: data
    })
}